import { 
  FaGlobe, 
  FaInfoCircle
} from 'react-icons/fa';

const SiteSettings = ({ settings, onSettingChange, loading = false }) => {
  return (
    <div>
      <h2 className="text-lg font-medium text-gray-900 mb-6">Site Settings</h2>
      
      <div className="space-y-6">
        {/* Basic Information */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-md font-medium text-gray-900 mb-4 flex items-center">
            <FaGlobe className="w-4 h-4 mr-2 text-primary-600" />
            Basic Information
          </h3>
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Site Name
                </label>
                <input
                  type="text"
                  value={settings.siteName || ''}
                  onChange={(e) => onSettingChange('siteName', e.target.value)}
                  disabled={loading}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                  placeholder="Your business name"
                />
                <p className="mt-1 text-xs text-gray-500">Displayed in the header and browser title</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tagline
                </label>
                <input
                  type="text"
                  value={settings.tagline || ''}
                  onChange={(e) => onSettingChange('tagline', e.target.value)}
                  disabled={loading}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                  placeholder="Brief business description"
                />
                <p className="mt-1 text-xs text-gray-500">A short phrase describing your business</p>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Site Description
              </label>
              <textarea
                value={settings.description || ''}
                onChange={(e) => onSettingChange('description', e.target.value)}
                disabled={loading}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                placeholder="Describe your business and services..."
              />
              <p className="mt-1 text-xs text-gray-500">
                Used for SEO and social media previews (120-160 characters recommended)
              </p>
            </div>
          </div>
        </div>

        {/* Help & Documentation */}
        <div>
          <h3 className="text-md font-medium text-gray-900 mb-4">Help & Documentation</h3>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex">
              <FaInfoCircle className="w-5 h-5 text-blue-400 mt-0.5" />
              <div className="ml-3">
                <h4 className="text-sm font-medium text-blue-900">Configuration Tips</h4>
                <div className="mt-2 text-sm text-blue-700">
                  <ul className="list-disc list-inside space-y-1">
                    <li>Site name appears in the header and browser title</li>
                    <li>Tagline is displayed on your homepage and marketing materials</li>
                    <li>Description appears in Google search results and social media previews</li>
                    <li>Keep descriptions between 120-160 characters for best SEO results</li>
                    <li>Email verification helps reduce spam registrations</li>
                    <li>Click "Save Changes" at the top to apply your modifications</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteSettings;